import React from 'react';

export default function IconIT() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 22">
            <path
                fill="#73AF00"
                d="M10.666 21.483H.551A.552.552 0 0 1 0 20.93V1.069C0 .764.247.517.55.517h10.115v20.966Z"
            />
            <path fill="#F5F5F5" d="M21.333.517H10.666v20.966h10.667V.517Z" />
            <path
                fill="#FF4B55"
                d="M31.448 21.483H21.333V.517h10.115c.305 0 .552.247.552.552V20.93a.552.552 0 0 1-.552.552Z"
            />
        </svg>
    );
}
